module.exports = __webpack_public_path__ + "static/media/orange-wallet-icon-102x102.f667cb3a.svg";